// components/MessageList.tsx
import React, { useEffect, useRef } from 'react';
import MessageItem from './MessageItem';
import Feedback from './Feedback/Feedback';

type Message = {
  messageId: string;
  conversationId: string;
  id: string;
  data: string;
  sender: 'user' | 'bot';
  fromDB?: boolean; // Optional property to indicate if the message is from the database
  citations?: {
    chunkId: string;
    filename: string;
    contents: string;
    messageId?: string | null; // Optional, can be null if not set
  }[];
};

type Props = {
  messages: Message[];
  // flag to indicate if user can send (false during bot response)
  canSend: boolean;
};

const MessageList = ({ messages, canSend }: Props) => {
  const endRef = useRef<HTMLDivElement>(null);
  const lastMessage = messages ? messages[messages.length - 1] : null

  // Scroll to bottom when messages change
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="messageList">
      {messages.map((msg) => (
          <MessageItem key={msg.id} citations={msg.citations} msgId={msg.id} data={msg.data} sender={msg.sender} />
      ))}
           
      {!canSend && (
        <div className='thinking-ref'>
          <span className="animate-pulse">
            ~ Bot is Thinking ~
          </span>
        </div>
      )}
      <div ref={endRef} >
        { messages.length > 0 && canSend && <div className='end-ref'>~ Response Complete ~</div> }
        {canSend && lastMessage && lastMessage.sender === 'bot' && lastMessage.fromDB !== true &&
            <div className=''>
            <Feedback
                conversationId={lastMessage.conversationId}
                messageId={lastMessage.id}
                sender={lastMessage.sender}
                content={lastMessage.data}
                question = {(messages.slice().reverse().find((msg) => msg.sender === 'user'))?.data || ''}
            />
            </div>
            
          }
      </div>
    </div>
  );
};

export default MessageList;
